import MonthlyHR from "./MonthlyHR";

export default function PayrollAttendance() {
  return <MonthlyHR kind="attendance" />;
}
